// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__2-QKu","ToggleWrapper":"Toggle_ToggleWrapper__3dU58","FadeIn":"Toggle_FadeIn__1eZ2X","MenuToggle":"Toggle_MenuToggle__xApvT"};